<template>
  <div>
    <el-dialog title="修改" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="formRef">
        <el-form-item :label="'旧机总价值'" prop="totalPrice" v-if="type == 'JD'">
          <el-input-number type="textarea" :precision="2" placeholder="请输入" :step="0.01" controls-position="right" v-model="form.totalPrice" :min="0.0" :max="99999999" />
        </el-form-item>
        <!-- <el-form-item v-if="type == 'JD'" :label="'旧机总信息费'" prop="totalInfoFee">
          <el-input-number type="textarea" :precision="2" placeholder="请输入" :step="0.01" controls-position="right" v-model="form.totalInfoFee" :min="0.0" :max="99999999" />
        </el-form-item> -->
        <el-form-item v-if="type !== 'JD'" v-for="(item, index) in airConditionerFields" :key="index" :label="item.label" :prop="item.prop">
          <el-input-number
            type="textarea"
            :placeholder="`请输入`"
            :step="item.step || 1"
            controls-position="right"
            v-model="form[item.prop]"
            :min="item.min || 0"
            :max="99999"
            :precision="item.precision !== undefined ? item.precision : 0"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelBtnFun">取 消</el-button>
        <el-button type="primary" @click="confirmBtnFun">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'JD'
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        id: undefined,
        totalPrice: undefined,
        // totalInfoFee: undefined,
        airConditionerWallHangingCount: 0,
        airConditionerPackagedCount: 0,
        airConditionerMobileCount: 0,
        televisionOldCount: 0,
        televisionNewCount: 0,
        washingMachineTumbleCount: 0,
        washingMachineDrumCount: 0,
        washingMachineDoubleCount: 0,
        fridgeOneCount: 0,
        fridgeTwoCount: 0,
        freezerCount: 0,
        electricWaterHeaterCount: 0,
        gasWaterHeaterCount: 0,
        airEnergyWaterHeaterCount: 0,
        wallHangingBoilerCount: 0,
        dishwasherCount: 0,
        rangeHoodCount: 0,
        gasStoveCount: 0,
        rangeHoodStoveSetCount: 0,
        integratedStoveCount: 0,
        embeddedDisinfectorCount: 0,
        showcaseOneCount: 0,
        showcaseTwoCount: 0
      },
      rules: {
        totalPrice: [{ required: true, message: '请输入总价值', trigger: 'blur' }],
        // totalInfoFee: [{ required: true, message: '请输入总信息费', trigger: 'blur' }]
      },
      // 空调相关字段配置
      airConditionerFields: [
        { label: '挂机数量', prop: 'airConditionerWallHangingCount', step: 1, min: 0, precision: 0 },
        { label: '柜机数量', prop: 'airConditionerPackagedCount', step: 1, min: 0, precision: 0 },
        { label: '移动空调数量', prop: 'airConditionerMobileCount', step: 1, min: 0, precision: 0 },
        { label: '老式显像管电视（19寸及以上）数量', prop: 'televisionOldCount', step: 1, min: 0, precision: 0 },
        { label: '液晶电视数量', prop: 'televisionNewCount', step: 1, min: 0, precision: 0 },
        { label: '液晶（32-49寸）-屏幕完好显示正常数量', prop: 'television3249GoodCount', step: 1, min: 0, precision: 0 },
        { label: '液晶（32-49寸）-屏幕破损/显示异常数量', prop: 'television3249BadCount', step: 1, min: 0, precision: 0 },
        { label: '液晶（50-69寸）-屏幕完好显示正常数量', prop: 'television5069GoodCount', step: 1, min: 0, precision: 0 },
        { label: '液晶（50-69寸）-屏幕破损/显示异常数量', prop: 'television5069BadCount', step: 1, min: 0, precision: 0 },
        { label: '液晶（70寸及以上）-屏幕完好显示正常数量', prop: 'television70PlusGoodCount', step: 1, min: 0, precision: 0 },
        { label: '液晶（70寸及以上）-屏幕破损/显示异常数量', prop: 'television70PlusBadCount', step: 1, min: 0, precision: 0 },

        { label: '波轮全自动洗衣机（4公斤以上）数量', prop: 'washingMachineTumbleCount', step: 1, min: 0, precision: 0 },
        { label: '滚筒洗衣机（4公斤以上）数量', prop: 'washingMachineDrumCount', step: 1, min: 0, precision: 0 },
        { label: '双缸洗衣机（4公斤以上）数量', prop: 'washingMachineDoubleCount', step: 1, min: 0, precision: 0 },
        { label: '冰箱（100升以上）数量', prop: 'fridgeOneCount', step: 1, min: 0, precision: 0 },
        { label: '冰箱（100升以下）数量', prop: 'fridgeTwoCount', step: 1, min: 0, precision: 0 },
        { label: '冷柜（200升以上）数量', prop: 'freezerCount', step: 1, min: 0, precision: 0 },
        { label: '电热水器数量', prop: 'electricWaterHeaterCount', step: 1, min: 0, precision: 0 },
        { label: '燃气热水器数量', prop: 'gasWaterHeaterCount', step: 1, min: 0, precision: 0 },
        { label: '空气能热水器数量', prop: 'airEnergyWaterHeaterCount', step: 1, min: 0, precision: 0 },
        { label: '壁挂炉数量', prop: 'wallHangingBoilerCount', step: 1, min: 0, precision: 0 },
        { label: '洗碗机数量', prop: 'dishwasherCount', step: 1, min: 0, precision: 0 },
        { label: '油烟机数量', prop: 'rangeHoodCount', step: 1, min: 0, precision: 0 },
        { label: '燃气灶数量', prop: 'gasStoveCount', step: 1, min: 0, precision: 0 },
        { label: '烟灶套装数量', prop: 'rangeHoodStoveSetCount', step: 1, min: 0, precision: 0 },
        { label: '集成灶数量', prop: 'integratedStoveCount', step: 1, min: 0, precision: 0 },
        { label: '嵌入式消毒柜数量', prop: 'embeddedDisinfectorCount', step: 1, min: 0, precision: 0 },
        { label: '展示柜（100升~200升）数量', prop: 'showcaseOneCount', step: 1, min: 0, precision: 0 },
        { label: '展示柜（200升以上）数量', prop: 'showcaseTwoCount', step: 1, min: 0, precision: 0 },
      ]
    }
  },
  methods: {
    // 打开弹框
    openDialog(row) {
      this.form.id = row.id
      this.form.totalPrice = row.totalPrice
      // this.form.totalInfoFee = row.totalInfoFee
      this.airConditionerFields.forEach(field => {
        // 确保空值时默认为0
        this.form[field.prop] = row[field.prop] !== null && row[field.prop] !== undefined ? row[field.prop] : 0
      })
      this.dialogVisible = true
    },
    // 取消弹框
    cancelBtnFun() {
      this.$refs.formRef.clearValidate()
      this.clearParams()
      this.dialogVisible = false
    },
    clearParams() {
      this.form.id = undefined
      this.form.totalPrice = undefined
    },
    // 确认
    confirmBtnFun() {
      this.$refs.formRef.validate(valid => {
        let url =
          this.type === 'JD'
            ? '/autoapp-default-server-recovery/api/settlement/jdTotal/updateTotalPrice'
            : '/autoapp-default-server-recovery/api/settlement/orderTotal/updateBySpecificationCount'
        if (valid) {
          let params = {
            id: this.form.id,
            totalPrice: parseFloat(this.form.totalPrice).toFixed(2),
            // totalInfoFee: parseFloat(this.form.totalInfoFee).toFixed(2)
          }

          // 添加空调相关字段到参数中
          if (this.type !== 'JD') {
            this.airConditionerFields.forEach(field => {
              // 确保空值时发送0而不是空值
              params[field.prop] = this.form[field.prop] !== null && this.form[field.prop] !== undefined ? this.form[field.prop] : 0
            })
            delete params.totalPrice
            // delete params.totalInfoFee
          }

          const loading = this.$loading({
            lock: true,
            text: '提交中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });

          this.HttpService.post(url, this.global.clearEmptyParam(params)).then(res => {
            loading.close();
            if (res.statusCode === 200) {
              this.$message.success('已修改')
              this.dialogVisible = false
              this.$emit('getList')
              this.clearParams()
            } else {
              this.$message.error(res.message)
            }
          }).catch(error => {
            loading.close();
            this.$message.error('请求失败');
          })
        } else {
          this.$message.warning('请填写总价值')
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.dialog-footer {
  padding: 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/settlementManagement/components/TotalPriceUpdateModal.vue